import {Assert} from "common/Assert";
import {Event} from "common/Event";

/***********************************************************************
 Watcher for cookie changes. In case of cookie change, the given event
 will be fired.
 ***********************************************************************/
export function CookieChangeWatcher(){

    let cookieData = "",
        timoutId = -1,
        time = 0,
        cookieChangeEventId = null,
        dataToSend = null;

    function onCallbackInterval() {

        if( cookieHasChanged() ) {
            Event.trigger( document, cookieChangeEventId, dataToSend ? dataToSend : {} );
        }

        timoutId = window.setTimeout( onCallbackInterval, time );
    }

    function cookieHasChanged(){

        if (cookieData !== document.cookie) {
            cookieData = document.cookie;
            return true;
        }

        return false;
    }

    // revealing public api
    return {

        startTimer: function( checkIntervalTime, eventId, data ) {

            Assert.checkArgumentType(  checkIntervalTime, "number" );

            if( (timoutId !== -1) || ( checkIntervalTime <= 0) || ( typeof eventId !== "string" ) ) {
                return false;
            }

            time =  checkIntervalTime;
            cookieChangeEventId = eventId;
            dataToSend = data;
            timoutId = window.setTimeout( onCallbackInterval, 500 );

            return true;
        },

        stopTimer: function () {
            clearTimeout( timoutId );

            timoutId = -1;
            time = 0;
            cookieChangeEventId = null;
            dataToSend = null;
        }
    };
}
